
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiClhubService } from '../../_services/apiClhub.service';
import { MicrosoftGraphService } from '../../_services/microsoftGraph.service';
import { Select2Options } from '../../_models/select2/Select2Options';
import * as $ from 'jquery';

import { PowerBiObjectModel } from '../../_models/DAL/PowerBiObject.model';
import { RoleModel } from '../../_models/DAL/Role.model';
import { UserOrGroupModel } from '../../_models/DAL/UserOrGroup.model';
import { Subject, from, Subscription } from 'rxjs';
import { AccessLogModel, DALAccesLogModel } from '../../_models/DAL/AccessLog.model';
import { AuthenticationService } from '../../_services/authentication.service';
import { JDebug, LOG_LEVELS } from 'src/app/_helpers/debug.tools';
import * as _ from "lodash";
import { CommonTools } from 'src/app/_helpers/common.tools';
import { AccessModel } from 'src/app/_models/DAL/Access.model';
import { ADD, BiObjectHelperService, UPDATE, WITHOUT_ROLE } from 'src/app/_services/biObjectHelper.service';
import { PBIO_Helper } from 'src/app/_helpers/pbi.helper';

/*const Declarations*/
const MSGRAPH_API_URL_V1: string = 'https://graph.microsoft.com/v1.0';
const MSGRAPH_API_URL_BASE_CLIENT: string = `${MSGRAPH_API_URL_V1}/users`;
const MSGRAPH_API_URL_BASE_GROUP: string = `${MSGRAPH_API_URL_V1}/groups`;

export interface ScrollAnsStickyContainers{
  scrollContainer: HTMLElement;
  stickyContainer: HTMLElement;
}


@Component({
  selector: 'app-form-azure-object',
  templateUrl: './form-azure-object.component.html',
  styleUrls: ['./form-azure-object.component.css'],

})
export class FormAzureObjectComponent implements OnInit, AfterViewInit, OnDestroy {

  //#region Attributs
  private readonly _objectToEdit: PowerBiObjectModel = new PowerBiObjectModel();
  private _isAdd = false;

  public showEditOrAddRoleRow = 'hide';

  private _isCubeConnection = false;
  private _displayFilterTable = false;
  public _editCustomName = false;
  private _ErrorMessageEditCustomName = false;

  private _editRole = false;
  public _roleEditErrorMessage = false;

  public Select2Options: Select2Options;
  private _RoleToAddOrEdit: RoleModel = new RoleModel();
  //ordering ole management
  public rolesAreAsc: boolean = true;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  ApiUserOrGroup: Array<ClhubApiUserAccess>;

  get isCubeConnection(): boolean { return this._isCubeConnection; }
  set isCubeConnection(value: boolean) { this._isCubeConnection = value; }

  get displayFilterTable(): boolean { return this._displayFilterTable; }
  set displayFilterTable(value: boolean) { this._displayFilterTable = value; }

  get ErrorMessageEditCustomName(): boolean { return this._ErrorMessageEditCustomName; }
  set ErrorMessageEditCustomName(value: boolean) {
    if (value) {
      $('#inputGroupEditCustomName').addClass('has-error');
    } else {
      $('#inputGroupEditCustomName').removeClass('has-error');
    }
    this._ErrorMessageEditCustomName = value;
  }




  get RoleToAddOrEdit(): RoleModel { return this._RoleToAddOrEdit; }
  set RoleToAddOrEdit(value: RoleModel | null) { this._RoleToAddOrEdit = value; }

  private readyToSave: boolean = true;
  public submitDisabled: boolean = true;

  defaultValueForAzureInput = 'Séléctionner';
  listOfAllUsers: MsGraphUser[] = [];
  listOfAllGroups: MsGraphGroup[] = [];

  ReferenceListOfAllUsers: MsGraphUser[] = [];
  ReferenceListOfAllGroups: MsGraphGroup[] = [];

  errorFormParameter: string;

  objectToEditIsLoad: boolean = false;


  /*ADDS*/

  //loading management
  //test
  public objectIsInAPI = false;

  public emptyPowerBiObjectFilteredList: boolean = false;

  //subcriptions management
  private readonly subcriptions: Subscription = new Subscription();
  //Observable refactor Mangement
  private readonly unsubscribeAll = new Subject<void>();
  /************************************* */
  // Delete and close confirm modal
  public showDeleteConfirmModal: boolean = false;
  public showClosingConfirmModal: boolean = false;
  public showTransfertConfirmModal: boolean = false;

  public selectedindex = -1;
  //public canDelete = false;

  // link display
  public isRoleToAddOrEditHave_WithoutRole_: boolean = false;

  public isOnCreation: boolean = false;
  public isOnEdition: boolean = false;
  public haveChange: boolean = false;
  /*************************************** */
  //component css Beahvior
  public groupFormParametersBehaviorClass = "";
  //Reverting and backup
  private _RoleToAddOrEditBckp: RoleModel = new RoleModel();
  private _HaveChangeBckp: boolean = this.haveChange;

  // scroll & sticky container
  private tagScrollContainer!: HTMLElement;
  private dtScrollContainer!: HTMLElement;

  private tagStickyContainer! :HTMLElement;
  private dtStickyContainer! :HTMLElement;



  // adding this for readOnly deleted reports
  @Input()
  isReadOnly: boolean;

  jsonRoles = "";
  emptyReportlist: Array<PowerBiObjectModel>;
  /*END ADDS*/


  @Input()
  GroupSelected: { id: string; };
  @Input()
  isDashboard: any;


  get objectToEdit(): PowerBiObjectModel {
    return this._objectToEdit;
  }
  @Input()
  set objectToEdit(val: PowerBiObjectModel) {

    // this.TestProcess(val)

    this.rolesAndUsersLoadingProcess(val);

  }



  //#endregion Attributs
  constructor(
    private readonly BiObjectHelperService: BiObjectHelperService,
    private readonly ApiClient: ApiClhubService,
    private readonly microsoftGraph: MicrosoftGraphService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly AuthService: AuthenticationService,
    private readonly el: ElementRef) {
    this.Select2Options = new Select2Options();

    this.Select2Options.templateResult = icon => {
      const originalOption = icon.element;
      return $('<span><i class="fa ' + $(originalOption).data('icon') + '"></i> ' + icon.text + '</span>');
    };
  }

  ngOnDestroy(): void {
    this.subcriptions.unsubscribe();
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();

    // remove scroll listeners
    if (this.tagScrollContainer) {
      this.tagScrollContainer.removeEventListener('scroll', this.onScroll.bind(this, {stickyContainer : this.tagStickyContainer, scrollContainer: this.tagScrollContainer} as ScrollAnsStickyContainers));
    }
    if(this.dtScrollContainer) {
      this.dtScrollContainer.removeEventListener('scroll', this.onScroll.bind(this, {stickyContainer: this.dtStickyContainer, scrollContainer: this.dtScrollContainer} as ScrollAnsStickyContainers));
    }

  }


  ngOnInit() {
    const graphClient$ = from(this.microsoftGraph.GraphClientSubject);

    this.subcriptions.add(
      graphClient$.subscribe(
        (client) => {
          try {
            client.api('https://graph.microsoft.com/v1.0/users?$top=999').get().then(result => {
              this.listOfAllUsers = result.value;
              this.ReferenceListOfAllUsers = this.listOfAllUsers.map(x => ({ ...x }));
              JDebug.logObject(this.ReferenceListOfAllUsers, 'JDEBUG ReferenceListOfAllUsers');
            });

            client.api('https://graph.microsoft.com/v1.0/groups?$top=999').get().then(resultGroup => {
              this.listOfAllGroups = resultGroup.value;
              this.ReferenceListOfAllGroups = this.listOfAllGroups.map(x => ({ ...x }));
              JDebug.logObject(this.ReferenceListOfAllGroups, 'JDEBUG ReferenceListOfAllGroups');

              this.dtOptions = {
                pagingType: 'full_numbers',
                pageLength: 2
              }
            });
          } catch (error) {
            JDebug.logError(error);
            console.error(error);
          }

        }
      )
    );
    this.BiObjectHelperService.getEmptyReportsList(this.objectToEdit.azureWorkspaceId).then(
      arr => {
        if (arr) this.emptyReportlist = arr;
        JDebug.logArray(this.emptyReportlist);
      }
    );

  }

  ngAfterViewInit(): void {
    $('#formUsers>span>span.selection>span').css('height', '34px').css('border', '1px solid #d2d6de').css('border-radius', '0px');


    //shadow management on scroll
    this.tagScrollContainer = this.el.nativeElement.querySelector('#tagScrollContainer');
    this.tagStickyContainer = this.el.nativeElement.querySelector('#tagFormStickyContainer');
    if (this.tagScrollContainer) {
      this.tagScrollContainer.addEventListener('scroll',this.onScroll.bind(this, {stickyContainer : this.tagStickyContainer, scrollContainer: this.tagScrollContainer} as ScrollAnsStickyContainers));
    }
    this.dtScrollContainer = this.el.nativeElement.querySelector('#scrollableReportModelContent');
    this.dtStickyContainer = this.el.nativeElement.querySelector('#StickyDtHeader');
    if (this.dtScrollContainer) {
      this.dtScrollContainer.addEventListener('scroll', this.onScroll.bind(this, {stickyContainer : this.dtStickyContainer, scrollContainer: this.dtScrollContainer} as ScrollAnsStickyContainers));
    }

    // Who that ?
    // this.dtTrigger.next();
  }


  //#region TEST Management
  /*
  ####################################################TEST###############################################################
  ####################################################TEST###############################################################
  ####################################################TEST###############################################################
  */

  async TestProcess(val: any) {
    // Test Area document : implement and decomment call in  set objectToEdit(val: PowerBiObjectModel) {
  }
  /*
   ####################################################TEST###############################################################
   ####################################################TEST###############################################################
   ####################################################TEST###############################################################
   */
  //#endregion TEST Management

  //shadow management on scroll
  onScroll(value : ScrollAnsStickyContainers): void {
    // check scroll
    const scrollTop = value.scrollContainer.scrollTop; // read current scroll
    //toggle shadow
    value.stickyContainer.classList.toggle('shadowed', scrollTop > 0);
  }

  UpdateSubmitDesabling() {
    this.submitDisabled = !this.haveChange;
  }

  sortRoles() {
    const rolesCopy = [...this.objectToEdit.roles]; // Création d'une copie pour éviter la mutation
    rolesCopy.sort((a, b) => CommonTools.BaseSortCb(a.theRole, b.theRole)); // Tri sur la copie

    this.objectToEdit.roles = this.rolesAreAsc ? [...rolesCopy].reverse() : rolesCopy;
    JDebug.logObject(this.objectToEdit.roles, 'sortRoles : objectToEdit.roles');
    this.toggleAscFalg();
  }

  toggleAscFalg() {
    this.rolesAreAsc = !this.rolesAreAsc;
    this.cdRef.detectChanges();
  }
  setAscFlag(bool: boolean) {
    this.rolesAreAsc = bool;
    this.cdRef.detectChanges();
  }


  Check_RoleToAddOrEdit_Is_WithoutRole() {
    this.isRoleToAddOrEditHave_WithoutRole_ = this.objectToEdit.roles.some(r => r.theRole === WITHOUT_ROLE);
  }


  roleFilter = ''; // Variable pour le filtre des rôles

  // Méthode de filtre des rôles
  filteredRoles() {
    if (!this.roleFilter) {
      return this.objectToEdit.roles;
    }
    return this.objectToEdit.roles.filter(role =>
      role.theRole.toLowerCase().includes(this.roleFilter.toLowerCase())
    );
  }


  //#region roles & UserOrGroup Loading process

  async rolesAndUsersLoadingProcess(val: any) {

    JDebug.resetPassOrder();
    JDebug.logObject(this.AuthService.currentUserValue, 'hydrate current user');
    this.inflateObjectToEdit(val);
    this.objectIsInAPI = this.objectToEdit.id != 0;

    const result = await this.BiObjectHelperService.getClhubPBIOByAzureObjectId(val.azureObjectId);

    this.emptyPowerBiObjectFilteredList = true;

    if (!result) {
      this._isAdd = true;


    } else {
      this._isAdd = false;

      JDebug.logValue(this._isAdd, "isAdd")
      this._isCubeConnection = result[0].isCubeConnection;
      this._displayFilterTable = result[0].displayFilterTable;


      const roles = await this.BiObjectHelperService.getClhubRolesByPowerBIObjectId(result[0].id);

      for (const obj of roles) {

        const Role = this.BiObjectHelperService.inflateRole(obj);

        result[0].roles.push(Role);
        result[0].roles.sort((a, b) => CommonTools.BaseSortCb(a.theRole, b.theRole));

        this.ApiUserOrGroup = await this.BiObjectHelperService.getClhubUserOrGroupsByRolesId(Role.id);
        JDebug.logObject(this.ApiUserOrGroup, 'JEDUG resultUsersOrGroups');
        // We have 1/n user or/and 1/n group
        if (this.ApiUserOrGroup[0]) {

          // For each UserOrGroup
          for (const userOrGroup of this.ApiUserOrGroup) {

            let isUser = !userOrGroup['isGroup'];
            let graphUrl = (isUser) ? MSGRAPH_API_URL_BASE_CLIENT : MSGRAPH_API_URL_BASE_GROUP

            try {
              //get user info @ Microsoft
              const graphApiObjResult = await this.microsoftGraph.GraphClient.api(`${graphUrl}/${userOrGroup['azureObjectId']}`).get();

              const user = this.inflateUserOrGroupModel(userOrGroup, graphApiObjResult);
              if (isUser) this.loadUserAccess(userOrGroup, user);

              const index = result[0].roles.findIndex(
                role => role.id === Role.id
              );

              if (index > -1) {
                result[0].roles[index].usersOrGroups.push(user);
                result[0].roles[index].usersOrGroups.sort((a, b) => CommonTools.BaseSortCb(a.name, b.name));
                JDebug.logArray(result, " Result", LOG_LEVELS.INFO)
                this.cdRef.detectChanges();
              }

            }//try
            catch (error) {
              console.error(`ERROR: microsoftGraph.GraphClient.api, azureObjectId ${userOrGroup['azureObjectId']}
                    ${error} `);
            }//catch

          }//for
        } else {
          this.emptyPowerBiObjectFilteredList = true;
        }

        // Ensuite, nous allons chercher l'historique d'accès à ce rôle.
        const lastAccesslogList$ = from(this.ApiClient.get('AccessLog/last-accesslog-list/' + Role.id));
        this.subcriptions.add(
          lastAccesslogList$.subscribe(

            (resultLastAccessLog) => {
              for (const lastAccessLog of resultLastAccessLog) {

                const userOrGroupLastAcess$ = from(this.ApiClient.get('UserOrGroup/' + lastAccessLog.UserOrGroupId));

                this.subcriptions.add(
                  userOrGroupLastAcess$.subscribe(UserOrGroup => {
                    const acceslog = this.inflateLastAcceslog(lastAccessLog, UserOrGroup, Role.theRole);
                    this.objectToEdit.accessLog.push(acceslog);
                  })
                )//add
              }//for
            }//next
            , err => console.error(err)
            , () => JDebug.tag("COMPLETE 398")
          )
        );

        if (Role.modifiedBy !== 0) {
          const UserOrGroupModifiedById$ = from(this.ApiClient.get('UserOrGroup/' + Role.modifiedBy));
          this.subcriptions.add(
            UserOrGroupModifiedById$.subscribe(
              modifiedByResult => {
                const index = result[0].roles.findIndex(
                  role => role.id === Role.id
                );
                if (index > -1) {
                  result[0].roles[index].modifiedByUserOrGroup = modifiedByResult;
                  this.cdRef.detectChanges();
                }
              }
            )
          );
        }

        // Sort the Role-AccessLogs by last views
        this.objectToEdit.accessLog.sort((x: { roleName: string; viewAt: Date; }, y: { roleName: any; viewAt: Date; }) => {
          return x.roleName.localeCompare(y.roleName) || new Date(x.viewAt).getUTCDate() - new Date(y.viewAt).getUTCDate()
        });

      }

      this._objectToEdit.roles = result[0].roles;

    }
    this.objectToEditIsLoad = true;

    JDebug.elevatedTag(`End Of Load objectToEditIsLoad ${this.objectToEditIsLoad}`);
    this.cdRef.detectChanges();
  }

  /**
   * next
   * Découpage en méthodes privées :
   *   processRoles
    *  processUsersOrGroups
     * processAccessLogs
      *processModifiedBy
   */



  //#endregion roles & UserOrGroup Loading process


  formGroup = new FormGroup({
    idObjectPowerBi: new FormControl(''),
    idGroupPowerBi: new FormControl(''),
    parameters: new FormControl(''),
    User: new FormControl(''),
    isDashbord: new FormControl(''),
    isReport: new FormControl(''),

  });

  //#region UserAndGroup Management

  addUserOrGroup(userOrGroup: UserOrGroupModel) {
    // on flag en nouveau
    userOrGroup.isNew = true;
    // On ajout le groupe à la liste
    this.RoleToAddOrEdit.usersOrGroups.push(userOrGroup);
    JDebug.logObject(this.RoleToAddOrEdit.usersOrGroups, 'JDEBUG RoleToAddOrEdit usersOrGroups');

    this.RoleToAddOrEdit.usersOrGroups.sort((a, b) => CommonTools.BaseSortCb(a.name, b.name));

    // Recherche si user ou group
    if (userOrGroup.isGroup) {
      // Supprimer du select
      const index = this.listOfAllGroups.findIndex(obj => obj.id === userOrGroup.azureObjectId);
      if (index > -1) {
        this.listOfAllGroups.splice(index, 1);
        this.haveChange = true;
        this.cdRef.detectChanges();
        return true;
      } else {
        this.cdRef.detectChanges();
        return false;
      }
    } else {

      // Supprimer du select
      const index = this.listOfAllUsers.findIndex(obj => obj.id === userOrGroup.azureObjectId);
      if (index > -1) {
        this.listOfAllUsers.splice(index, 1);
        this.haveChange = true;
        this.cdRef.detectChanges();
        return true;
      } else {
        this.cdRef.detectChanges();
        return false;
      }
    }
  }


  removeUserOrGroup(UserOrGroup: UserOrGroupModel) {
    const index = this.RoleToAddOrEdit.usersOrGroups.findIndex(obj => obj.azureObjectId === UserOrGroup.azureObjectId);
    if (index > -1) {
      this.RoleToAddOrEdit.usersOrGroups.splice(index, 1);
      if (UserOrGroup.isUser) {
        this.listOfAllUsers.push({ id: UserOrGroup.azureObjectId, displayName: UserOrGroup.name } as MsGraphUser);
      } else {
        this.listOfAllGroups.push({ id: UserOrGroup.azureObjectId, displayName: UserOrGroup.name } as MsGraphGroup);
      }
      this.haveChange = true;
      this.cdRef.detectChanges();
      return true;
    } else {
      this.cdRef.detectChanges();
      return false;
    }
  }

  //#region tag input test
  // roleTags: string[] = [];
  tagInput: string = '';
  filteredOptions: UserOrGroupModel[] = [];
  uogSelectedIndex: number = -1; // Index de l'élément sélectionné

  @ViewChild('UserOrGroupSuggestorContainer') suggestionContainer!: ElementRef;

  filterOptions() {
    const input = this.tagInput.trim().toLowerCase();

    if (input) {
      this.filteredOptions = [
        ...this.listOfAllUsers.filter(user => user.displayName.toLowerCase().includes(input)).map(user => (this.inflateUserOrGroupModel({ azureObjectId: user.id, isUser: true, isGroup: false } as unknown as ClhubApiUserAccess, user))),
        ...this.listOfAllGroups.filter(group => group.displayName.toLowerCase().includes(input)).map(group => (this.inflateUserOrGroupModel({ azureObjectId: group.id, isUser: false, isGroup: true } as unknown as ClhubApiUserAccess, group))),
      ];
    } else {
      this.filteredOptions = [];
    }
    JDebug.logArray(this.filteredOptions, 'JDEBUG filteredOptions');
    this.uogSelectedIndex = -1; // Réinitialiser la sélection
  }


  addTag(option: UserOrGroupModel) {
    this.tagInput = ''; // Réinitialiser l'entrée après l'ajout
    this.filteredOptions = []; // Cacher les suggestions
    JDebug.logObject(this.ApiUserOrGroup, 'JDebug ApiUserOrGroup');
    this.uogSelectedIndex = -1;
    this.addUserOrGroup(option);

  }
  onKeyDown(event: KeyboardEvent) {
    if (this.filteredOptions.length === 0) return;

    switch (event.key) {
      case 'ArrowDown': // Flèche bas : aller à l'élément suivant
        event.preventDefault();
        this.setSelectedIndex((this.uogSelectedIndex + 1) % this.filteredOptions.length);
        this.scrollToSelected();
        JDebug.logValue(this.uogSelectedIndex, 'JDebug arrow down uogSelectedIndex');
        JDebug.logObject(this.suggestionContainer, 'JDebug suggestionContainer');
        break;
      case 'ArrowUp': // Flèche haut : aller à l'élément précédent
        event.preventDefault();
        this.setSelectedIndex((this.uogSelectedIndex - 1 + this.filteredOptions.length) % this.filteredOptions.length);
        this.scrollToSelected();
        JDebug.logValue(this.uogSelectedIndex, 'JDebug arrow up uogSelectedIndex');
        break;
      case 'Enter': // Entrée : sélectionner l'élément en surbrillance
        event.preventDefault();
        if (this.uogSelectedIndex >= 0) {
          this.addTag(this.filteredOptions[this.uogSelectedIndex]);
        }
        break;
      case 'Escape': // Échapper : fermer la liste
        this.filteredOptions = [];
        break;
    }
  }
  setSelectedIndex(index: number) {
    this.uogSelectedIndex = index;
  }
  scrollToSelected() {
    if (!this.suggestionContainer) return;
    setTimeout(() => {
      const container = this.suggestionContainer.nativeElement;
      const selectedItem = container.querySelector(`[data-index="${this.uogSelectedIndex}"]`);

      if (selectedItem) {
        const containerHeight = container.clientHeight;
        const itemOffset = selectedItem.offsetTop;
        const itemHeight = selectedItem.clientHeight;

        if (itemOffset < container.scrollTop) {
          // Si l'élément sélectionné est au-dessus de la zone visible
          container.scrollTop = itemOffset;
        } else if (itemOffset + itemHeight > container.scrollTop + containerHeight) {
          // Si l'élément est en dessous de la zone visible
          container.scrollTop = itemOffset - containerHeight + itemHeight;
        }
      }
    });
  }

  //#endregion tag input test



  //#endregion UserAndGroup Management

  setReportOrDashboardWithoutRole() {
    $('#formParameters').val(WITHOUT_ROLE);
    // set flag just for the update anbd mask infos
    this.isRoleToAddOrEditHave_WithoutRole_ = true;
    // up changes
    this.haveChange = true;
    this.cdRef.detectChanges();
  }

  //#region CustomName Management

  editCustomName() {
    this._editCustomName = true;
    this.readyToSave = false;
    $('#editCustomName').val(this._objectToEdit.customName);
  }
  validCustomName() {
    this.objectToEdit.customName = $('#editCustomName').val().toString();
    this.haveChange = true;
    this._editCustomName = false;
    this.ErrorMessageEditCustomName = false;
    this.readyToSave = true;
    this.setOnChangeFlag();
  }

  //#endregion CustomName Management

  //#region Role Management
  //#region Add/Send Role
  /*Add/Send Role Sub func*/
  resetGroupFormParametersErrors() {
    $('#groupFormParameters').removeClass('has-error');
    this.readyToSave = true;
    this._roleEditErrorMessage = false;
    this.errorFormParameter = '';
    this.haveRoleNameError = false;
  }
  displayGroupFormParameterErrorAndSetDefault(msg: string) {
    $('#groupFormParameters').addClass('has-error');
    this.errorFormParameter = msg;
    this.readyToSave = false;
    this._editRole = true;

    this.isOnEdition = true;
    this.haveChange = true;
  }
  disposeUserAndRoleMgr() {
    this.hideUserAndRoleMgr();
    this.resetRoleToAddOrEditAndLists();
    this.resetGroupFormParametersErrors();

    this.groupFormParametersBehaviorClass = "";
    this.isRoleToAddOrEditHave_WithoutRole_ = false;

    this.readyToSave = true;
    this.UpdateSubmitDesabling();
    this._roleEditErrorMessage = false;
    this._editRole = false;


  }
  //#endregion Add/Send Role
  haveRoleNameError = false;
  checkRoleName(role: string) {
    this.resetGroupFormParametersErrors();
    this.haveRoleNameError = false;
    if (role.replace(' ', '') === '') {
      this.displayGroupFormParameterErrorAndSetDefault('Le rôle ne doit pas être vide.');
      this.haveRoleNameError = true;
    }
    if (PBIO_Helper.defineRoleIsPBIO(this.objectToEdit, role)) {
      this.displayGroupFormParameterErrorAndSetDefault('Ce rôle existe déja.');
      this.haveRoleNameError = true;
    }
  }

  // Méthode pour récupérer un rôle dans objectToEdit.roles par ID
  getRoleById(roleId: number) {
    return this.objectToEdit.roles.find(role => role.id === roleId);
  }
  // Méthode pour récupérer le rôle à partir de l'indice dans la liste filtrée
  getRoleByFilteredIndex(indice: number) {
    const filtered = this.filteredRoles();
    if (filtered.length > 0 && indice < filtered.length) {
      const role = filtered[indice];
      return role;
      /* JDR 20250716 - FIX Bad index with multi newest roles --
      The newest roles are an undefined id 
      This return th fisrt eklement of objectToEdit.roles with an id equal to undefined
      return this.getRoleById(role.id); // Recherche dans objectToEdit.roles basé sur l'ID du rôle  
      */
    }
    return null; // Retourne null si l'indice est invalide
  }
  // Méthode pour récupérer l'index du rôle dans objectToEdit.roles
  retrieveRoleIndexInFromFilteredIndex(index: number) {
    const role = this.getRoleByFilteredIndex(index);
    return  this._objectToEdit.roles.indexOf(role);
  }
  // Clear le filtre des rôles
  clearRoleFilter(){
    this.roleFilter = '';
  }

  // Mise à jour du role éditer dans l'objectToEdit
  sendRole() {
    const role = $('#formParameters').val().toString();

    this.checkRoleName(role);
    if (this.haveRoleNameError) return;

    this.isOnEdition = true;

    this.RoleToAddOrEdit.theRole = role;

    PBIO_Helper.clearNewFlags(this.RoleToAddOrEdit.usersOrGroups);

    this.RoleToAddOrEdit.usersOrGroups.sort((a, b) => CommonTools.BaseSortCb(a.name, b.name));
    this.setAscFlag(true);

    this.addRoleToObjectToEdit(this.RoleToAddOrEdit);

    this.disposeUserAndRoleMgr();

    if (this.isOnCreation) this.isOnCreation = !this.isOnCreation;
    this.isOnEdition = false;
    this.haveChange = true;
    this.clearRoleFilter();
  }
  // Edition d'un rôle
  editRole(indice: number) {
    this.Check_RoleToAddOrEdit_Is_WithoutRole();
    this.isOnEdition = true;
    this.groupFormParametersBehaviorClass = "disabled";

    // this.RoleToAddOrEdit = this._objectToEdit.roles[indice];
    //management wtih filtred list
    // retrieve related role
    this.RoleToAddOrEdit = this.getRoleByFilteredIndex(indice);
    if (this.RoleToAddOrEdit) JDebug.logObject(this.RoleToAddOrEdit, "editRole RoleToAddOrEdit");

    this.backup_EditRoleStates();
    this.backup_haveChangeState();

    $('#formParameters').val(this.RoleToAddOrEdit.theRole);

    this.readyToSave = false;
    this._editRole = true;

    for (const userOrGroup of this.RoleToAddOrEdit.usersOrGroups) {
      (userOrGroup.isGroup) ?
        CommonTools.findAndSpliceById(this.listOfAllGroups, userOrGroup.azureObjectId)
        :
        CommonTools.findAndSpliceById(this.listOfAllUsers, userOrGroup.azureObjectId);
    }

    this.showRowForm('');

    //Object to Edit & filter Management
    const RoleToAddOrEditIndex = this.retrieveRoleIndexInFromFilteredIndex(indice)
    if (RoleToAddOrEditIndex !== -1) {
      JDebug.logObject(RoleToAddOrEditIndex, "jdebug RoleToAddOrEditIndex");
      this.removeRoleToObjectToEdit(RoleToAddOrEditIndex);
    }
    // clear filters
    this.clearRoleFilter();

    this.haveChange = true;

  }



  cancelEditRole() {

    this.rollback_haveChangeState();
    //no control we rollback on a stable state
    this.rollback_EditRoleStates();



    if (this.isOnCreation) {
      this.isOnCreation = false;
    } else {

      // re-update user-groups displayble list for this role
      for (const userOrGroup of this.RoleToAddOrEdit.usersOrGroups) {
        (userOrGroup.isGroup) ?
          this.listOfAllGroups.push({ id: userOrGroup.azureObjectId, displayName: userOrGroup.name } as MsGraphGroup)
          :
          this.listOfAllUsers.push({ id: userOrGroup.azureObjectId, displayName: userOrGroup.name } as MsGraphUser);
      }

      // main treat has addRole if is an update
      this.addRoleToObjectToEdit(this.RoleToAddOrEdit);
    }


    this.disposeUserAndRoleMgr();
    this.isOnEdition = false;

    //clean input tag
    this.tagInput = '';

    this.clearRoleFilter();

    // up changes
    this.cdRef.detectChanges();

  }
  //#endregion Role Management

  //#region EditAction Management
  hideUserAndRoleMgr() {
    $('#formParameters').val('');
    this.showRowForm('hide');
  }
  resetRoleToAddOrEditAndLists() {
    this.RoleToAddOrEdit = new RoleModel();
    // On remet à zéro les listes
    this.listOfAllGroups = [];
    this.listOfAllGroups = this.ReferenceListOfAllGroups;

    this.listOfAllUsers = [];
    this.listOfAllUsers = this.ReferenceListOfAllUsers;
    this.cdRef.detectChanges();
  }

  //#endregion EditAction Management

  //#region ObjectToEdit Management
  removeRoleToObjectToEdit(indice: number) {
    this._objectToEdit.roles.splice(indice, 1);

    this.haveChange = true;
    this.cdRef.detectChanges();
  }
  addRoleToObjectToEdit(role: RoleModel) {
    this.objectToEdit.roles.push(role);

    this.objectToEdit.roles.sort((a, b) => CommonTools.BaseSortCb(a.theRole, b.theRole));
    this.setAscFlag(true);
  }
  //#endregion ObjectToEdit Management

  showRowForm(val: string) {
    this.showEditOrAddRoleRow = val;
    this.cdRef.detectChanges();
  }

  /*BTN Func*/

  /*ADD role Btn function*/
  openPopEditForAddRole(val: string) {
    this.Check_RoleToAddOrEdit_Is_WithoutRole();
    this.isOnCreation = true;
    this.isOnEdition = true;
    this.groupFormParametersBehaviorClass = "";
    this.backup_haveChangeState();
    this.backup_EditRoleStates();
    this.showRowForm(val);
  }

  onSubmit() {
    this.submitDisabled = true;
    if (!this.readyToSave) {
      if (this._editCustomName) {
        this.ErrorMessageEditCustomName = true;
      }

      if (this._editRole) {
        this._roleEditErrorMessage = true;
      }
      return false;
    }


    // 20240723 Adding Roles on New report or dashbords not in API
    // Temporary check if this.objectToEdit.id  === 0 >> is an add
    // T0D0:  check if the boolean is setted correctely
    if (this._isAdd || (this.objectToEdit.id === 0)) {
      this.objectToEdit.isReport = !this.isDashboard;
      this.objectToEdit.isDashboard = this.isDashboard;
      this.objectToEdit.isCubeConnection = this.isCubeConnection;
      this.objectToEdit.displayFilterTable = this.displayFilterTable;
      this.BiObjectHelperService.managePBIO(ADD, this.objectToEdit);
      this.closeAndReload();

    } else {
      this.objectToEdit.isCubeConnection = this.isCubeConnection;
      this.objectToEdit.displayFilterTable = this.displayFilterTable;
      this.BiObjectHelperService.managePBIO(UPDATE, this.objectToEdit);
      this.closeModal();

    }
  }

  /*ObjectToEdit managment*/
  inflateLastAcceslog(lastAccessLog: DALAccesLogModel, userOrGroup: UserOrGroupModel, roleName: string) {
    const accessLog = new AccessLogModel();
    accessLog.userOrGroup = userOrGroup;
    accessLog.roleId = lastAccessLog.RoleId;
    accessLog.viewAt = lastAccessLog.ViewAt;
    accessLog.accessLogId = lastAccessLog.Id;
    accessLog.roleName = roleName;
    return accessLog;
  }

  inflateObjectToEdit(val, context = this) {
    context._objectToEdit.customName = val.customName;
    context._objectToEdit.azureObjectId = val.azureObjectId;
    context._objectToEdit.azureWorkspaceId = context.GroupSelected.id;
    context._objectToEdit.id = val.id;
    context._objectToEdit.currentUserAzureObjectId = context.AuthService.currentUserValue.azure_id;
    context._objectToEdit.isDashboard = val.isDashboard;
    context._objectToEdit.isReport = val.isReport;
    context._objectToEdit.isCubeConnection = val.isCubeConnection;
    context._displayFilterTable = val.displayFilterTable;
  }
  //Merge Values
  inflateUserOrGroupModel(clhubApiUserOrGroup: ClhubApiUserAccess, msGraghObjResult: MsGraphGroup | MsGraphUser): UserOrGroupModel {
    let uOgObj = new UserOrGroupModel();
    uOgObj.id = clhubApiUserOrGroup['id'];
    uOgObj.azureObjectId = clhubApiUserOrGroup['azureObjectId'];
    uOgObj.isGroup = clhubApiUserOrGroup['isGroup'];
    uOgObj.isUser = clhubApiUserOrGroup['isUser'];
    uOgObj.userMail = msGraghObjResult.mail;
    if (this.isMsGraphUser(msGraghObjResult)) {
      uOgObj.userGivenName = msGraghObjResult.givenName;
      uOgObj.userSurname = msGraghObjResult.surname;
    }
    uOgObj.name = msGraghObjResult.displayName;
    return uOgObj;
  }
  isMsGraphUser(obj: any): obj is MsGraphUser {
    return ('givenName' in obj && 'surname' in obj);
  }
  loadUserAccess(userOrGroup: any, user: UserOrGroupModel) {
    userOrGroup['access'].forEach((access: AccessModel) => {
      user.access.push(access);
    });
  }

  //#region Backup
  /*Backup and rollback*/
  private backup_EditRoleStates() { this._RoleToAddOrEditBckp = _.cloneDeep(this.RoleToAddOrEdit); }
  private rollback_EditRoleStates() { this.RoleToAddOrEdit = _.cloneDeep(this._RoleToAddOrEditBckp); }

  private backup_haveChangeState() { this._HaveChangeBckp = this.haveChange; }
  private rollback_haveChangeState() { this.haveChange = this._HaveChangeBckp; }
  //#endregion Backup


  //#region Sub Modals
  //#region Main Close Modals
  /************* Sub Modals and Close Function*/
  @Output()
  public closeModalClicked: EventEmitter<{ open: boolean, reload: boolean }> = new EventEmitter<{ open: boolean, reload: boolean }>();
  closeClosingConfirmModal() { this.showClosingConfirmModal = false; }
  /* Main modal Close function */
  closeModal() { this.closeModalClicked.emit({ open: false, reload: false }); }
  closeAndReload() { this.closeModalClicked.emit({ open: false, reload: true }); }
  preventSave() {
    if (!this.haveChange) {
      this.showClosingConfirmModal = false;
      this.closeModal();
    } else {
      this.showClosingConfirmModal = true;
    }
  }
  saveAndQuit() {
    const role = $('#formParameters').val().toString();
    if (this._editRole || (role.replace(' ', '') !== '')) this.sendRole();
    this.onSubmit();
    this.submitDisabled = true
    this.closeModal();
  }
  //#endregion Main Close Modals

  //#region Confirm Modals
  /**Confirm Modal : Removing roles */
  closeDeleteConfirmModal() {
    this.isOnEdition = false;
    this.selectedindex = -1;
    this.showDeleteConfirmModal = false;
  }
  openDeleteConfirmModal(i: number) {
    this.selectedindex = i;
    this.showDeleteConfirmModal = true;
  }
  cancelDeleteRole() { this.closeDeleteConfirmModal(); }

  confirmDeleteRole() {
    const objectToEditIndex = this.retrieveRoleIndexInFromFilteredIndex(this.selectedindex);
    this.removeRoleToObjectToEdit(objectToEditIndex);
    this.closeDeleteConfirmModal();
    this.submitDisabled = false;
  }
  /** Confirm Modal : Transfert Roles */
  openTransfertConfirmModal() { this.showTransfertConfirmModal = true }
  closeTransfertConfirmModal() { this.showTransfertConfirmModal = false }
  confirmTransfertRole() { this.validateTransfert(); this.closeTransfertConfirmModal(); }
  cancelTransfertRole() { this.closeTransfertConfirmModal() }
  //#endregion Confirm Modals
  /**END MODALS */
  //#endregion Sub Modals

  toggleIsCubeConnection() {
    if (!this.isOnEdition) {
      this.isCubeConnection = !this.isCubeConnection;
      this.setOnChangeFlag();
    }
  }
  toggleDisplayFilterTable() {
    if (!this.isOnEdition) {
      this.displayFilterTable = !this.displayFilterTable;
      this.setOnChangeFlag();
    }
  }
  setOnChangeFlag() {
    this.submitDisabled = false;
    this.haveChange = true;
  }


  /*********************************************************************** */


  ///#region  Empty List management
  selectedEmptyReportId: number;
  selectedEmptyReport: PowerBiObjectModel;

  selectEmptyReport(guid: string) {
    JDebug.logValue(guid,'GUID à rechercher :');
    JDebug.logTab(this.emptyReportlist, 'Tableau emptyReportlist :');

    this.selectedEmptyReport = this.emptyReportlist.find(e => e.azureObjectId == guid);
    JDebug.logObject(this.selectedEmptyReport);
  }
  //#endregion  Empty List management

  //#region JSON Managment
  getJsonRoles() {
    this.jsonRoles = JSON.stringify(this._objectToEdit.roles, null, '\t');
    JDebug.logObject(this._objectToEdit);
  }
  //#endregin JSON Management


  // #region Tranfert Management
  async validateTransfert() {
    //controls & confirm PopUp?
    if (this.selectedEmptyReport == undefined) {
      alert("No Report selected");
      return;
    }
    this.BiObjectHelperService.duplicateRoles(this.selectedEmptyReport, this._objectToEdit);
    this.closeAndReload();
  }
  // #endregion Tranfert Management





}

